module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('router-link', {
    attrs: {
      "to": "/main"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/interview/static/img/iwlogo.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "user_nm"
  }, [_vm._v(_vm._s(_vm.cust_nm))]), _c('v-icon', {
    attrs: {
      "title": _vm.btn_title
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("exit_to_app")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b00f970","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 836
// module chunks = 1